export enum StateEnum {
  none = 'none',
  demande = 'demande',
  masse_salariale = 'masse_salariale',
  sbtcp = 'sbtcp',
  drh = 'drh',
  commission = 'commission',
  commission_decision = 'commission_decision',

  spta = 'spta',
  spte = 'spte',
  spta_traitement = 'spta_traitement', // stade candidat recruté
  recrutement = 'recrutement',
  recrutement_spte = 'recrutement_spte',

  publication = 'publication',

  refus = 'refus',

  clos = 'clos',

  archived = 'archived'
}
